import { IPlayUIStateProps } from "../..";
import { IDialogMapDispatchProps, IDialogMapStateProps } from "./Dialogs";
import { hideDialog } from "./Dialogs.actions";

export const sharedMapPropsToState = (
  state: IPlayUIStateProps
): IDialogMapStateProps => ({
  title: state.dialogs.title,
  message: state.dialogs.message,
  showing: state.dialogs.showing,
  cover: state.dialogs.cover,
  centerMessage: state.dialogs.centerMessage,
  buttons: state.dialogs.buttons,
  scrollable: state.dialogs.scrollable
});

export const sharedMapDispatchToProps = (
  dispatch
): IDialogMapDispatchProps => ({
  hideDialog: () => dispatch(hideDialog())
});
